<dx-data-grid 
  [glamResource]="seasonalities!" #warehouseSeasonalitiesDataGrid
  style="min-height:400px; width:600px;"
  >

  <dxi-column dataField="startDate" dataType="date" [caption]="'entity.productWarehouse.seasonality.startDate' | translate | ucfirst">
    <dxi-validation-rule type="required"/>
  </dxi-column>

  <dxi-column dataField="minStock" dataType="number" [caption]="'entity.productWarehouse.seasonality.minStock' | translate | ucfirst">
    <dxi-validation-rule type="required"/>
  </dxi-column>

  <dxi-column dataField="maxStock" dataType="number" [caption]="'entity.productWarehouse.seasonality.maxStock' | translate | ucfirst">
    <dxi-validation-rule type="required"/>
  </dxi-column>

  <dxi-column dataField="securityStock" dataType="number" [caption]="'entity.productWarehouse.seasonality.securityStock' | translate | ucfirst">
    <dxi-validation-rule type="required"/>
  </dxi-column>

  <dxi-column dataField="optimalOrderAmount" dataType="number" [caption]="'entity.productWarehouse.seasonality.optimalOrderAmount' | translate | ucfirst">
    <dxi-validation-rule type="required"/>
  </dxi-column>

</dx-data-grid>